import angular from 'angular';
import template from './template.html';
import BaseComponent from '../../../../base/component';
import { Inject } from '../../../../base/decorators';

export class EmployerRepSignUpEmail extends BaseComponent {
    @Inject('$stateParams') $stateParams;
    @Inject('EmployerRepService') employerRepService;

    async setupComponentData() {
        const { employerRepId } = this.$stateParams;

        if (!employerRepId) {
            return this.closePage();
        }

        const { result: employerRep} = await this.employerRepService.getExistingEmployerRep(employerRepId);
        this.employerRep = employerRep;
    }

    closePage() {
        this.$state.go('logout');
    }

    goToSignUpDetailsPage() {
        this.$state.go('employerRep.signUp.details');
    }
}

export const EmployerRepSignUpEmailConfiguration = {
    template,
    controller: EmployerRepSignUpEmail,
    controllerAs: 'employerRepSignUpEmailCtrl',
};

angular
    .module('TALENYA-FE')
    .component('employerRepSignUpEmail', EmployerRepSignUpEmailConfiguration);

